import Input from '@mui/material/Input';
import InputAdornment from '@mui/material/InputAdornment';

import { SearchIcon } from '../../../../assets/icons/SearchIcon';
import classes from './SearchInput.module.scss';

export const SearchInput = ({
  value,
  onChange,
}: {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}) => {
  return (
    <Input
      onChange={onChange}
      value={value}
      className={classes.searchInput}
      id='search-input'
      placeholder='Search property'
      startAdornment={
        <InputAdornment position='start'>
          <SearchIcon />
        </InputAdornment>
      }
    />
  );
};
